import React from 'react'
import {Select, MenuItem} from '@material-ui/core'
import useStyles from './TFontSize.styles'

const TFontSize = props => {
  const classes = useStyles()
  return (
    <Select
      className={classes.root}
      defaultValue={Math.round(props.value)}
      value={Math.round(props.value)}
      onChange={props.onChange}
    >
      {FontSizeOptions.map((v, i) => (
        <MenuItem key={i} className={classes.option} value={v}>
          {v}
        </MenuItem>
      ))}
    </Select>
  )
}

export default TFontSize

const FontSizeOptions = [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96]
